<div style="height:100vh;display: flex;/* Adjust the height as needed */">
    <img style="height: 70vh; margin: auto;" src="../../../../assets/aca_images/404.svg" alt="404 Image">
</div>